import type { SiteInventoryHealth } from '@restDataAccess';

type SiteHealthItem<T> = T & { health?: SiteInventoryHealth };

/** Pending probes stay with reachable sites; only confirmed failures go below the divider. */
export const splitSitesByHealth = <T extends { site: { id: string } }>(
  sites: T[],
  healthBySiteId: Record<string, SiteInventoryHealth | undefined>
) => {
  const reachableOrPendingSites: SiteHealthItem<T>[] = [];
  const unhealthySites: SiteHealthItem<T>[] = [];

  for (const item of sites) {
    const health = healthBySiteId[item.site.id];
    const withHealth = { ...item, health };
    if (health === 'unhealthy') unhealthySites.push(withHealth);
    else reachableOrPendingSites.push(withHealth);
  }

  return { reachableOrPendingSites, unhealthySites };
};
